import { render, staticRenderFns } from "./SaleTaxGroupSaleTaxIds.vue?vue&type=template&id=7a2664a9&"
import script from "./SaleTaxGroupSaleTaxIds.vue?vue&type=script&lang=ts&"
export * from "./SaleTaxGroupSaleTaxIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports